module.exports = __webpack_public_path__ + "static/jellyfish_with_logo_large_glow-90cd8fe0c82e7d1c9614ed6b1a4a92b6.png";